import type { ApiResponse } from '@/types/api-response.types'
import type { FilterOption } from '@/types/filter.types'
import api from '../axios'

export const programService = {
  async getPrograms(): Promise<FilterOption[]> {
    const response: ApiResponse<FilterOption[]> = await api.get('/v1/program')
    return response.body.map(program => ({
      ...program,
      route: `/program?program=${program.idx}`
    }))
  },

  async getProgramCourses(idx: number): Promise<FilterOption[]> {
    const response: ApiResponse<FilterOption[]> = await api.get(`/v1/program/${idx}/course`)
    return response.body
  },
}
